import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationContext } from '@contexts/navigation/navigation-context';

/**
 * Hook to handle "smart" back navigation.
 * It will either go back to the previous route in the app history
 * or fallback to a default route if there is no history or the history is the same as the current route.
 */
export const useSmartGoBack = () => {
  const navigate = useNavigate();
  const {
    preventRedirect,
    setIsItemClicked,
    setRedirectUrl,
    route: { from: fromRoute, to: toRoute },
  } = useContext(NavigationContext);

  const smartGoBack = useCallback(
    (defaultRoute: string, forceDefaultRoute = false) => {
      const redirectUrl = forceDefaultRoute ? defaultRoute : fromRoute;

      if (preventRedirect) {
        setIsItemClicked(true);
        setRedirectUrl(redirectUrl);
      } else if (fromRoute === toRoute) {
        navigate(defaultRoute);
      } else {
        navigate(redirectUrl);
      }
    },
    [fromRoute, toRoute, navigate, preventRedirect, setIsItemClicked, setRedirectUrl]
  );

  return { smartGoBack };
};
